"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRegionFromIdentityPoolId = exports.getRegionFromUserPoolId = void 0;
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var regionParsers_1 = require("./regionParsers");
Object.defineProperty(exports, "getRegionFromUserPoolId", { enumerable: true, get: function () { return regionParsers_1.getRegionFromUserPoolId; } });
Object.defineProperty(exports, "getRegionFromIdentityPoolId", { enumerable: true, get: function () { return regionParsers_1.getRegionFromIdentityPoolId; } });
